export default __webpack_public_path__ + "static/media/01.cd45da26.png";